module.exports = __webpack_public_path__ + "frontImage.ecb9adb58d92427175bb.jpg";


//////////////////
// WEBPACK FOOTER
// C:/Users/yanir/Desktop/workspace/TheBooksLibrary/src/assets/image/frontImage.jpg
// module id = ../../../../../src/assets/image/frontImage.jpg
// module chunks = main